import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { AuditPage } from "@/pages/AuditPage";
import { LeakagePage } from "@/pages/LeakagePage";
import { AppointmentDetailPage, AppointmentsPage } from "@/pages/AppointmentsPage";
import { EzyVetSettingsPage } from "@/pages/EzyVetSettingsPage";
import { EzyVetWebhookLogsPage } from "@/pages/EzyVetWebhookLogsPage";
import { ReconciliationWorkbench } from "@/pages/ReconciliationWorkbench";
import { CornerstoneSettingsPage } from "@/pages/CornerstoneSettingsPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/leakage" element={<LeakagePage />} />
        <Route path="/appointments" element={<AppointmentsPage />} />
        <Route path="/appointments/:appointmentId" element={<AppointmentDetailPage />} />
        <Route path="/settings/integrations/ezyvet" element={<EzyVetSettingsPage />} />
        <Route path="/settings/integrations/ezyvet/logs" element={<EzyVetWebhookLogsPage />} />
        <Route path="/settings/integrations/cornerstone" element={<CornerstoneSettingsPage />} />
        <Route path="/reconciliation/:discrepancyId" element={<ReconciliationWorkbench />} />
        {/* Old address, still linked from emails and bookmarks */}
        <Route path="/integrations" element={<Navigate to="/settings/integrations/ezyvet" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
